import React from 'react'
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

function PaginationCustom(props) {
    const { pager, setPager, total } = props
    let currentPage = parseInt(pager?.offset / pager?.size) + 1
    let lastPage = parseInt(Math.ceil(total / pager?.size))

    if (currentPage > lastPage) currentPage = lastPage

    let startPage = currentPage - 2
    if (startPage < 1) startPage = 1

    let endPage = currentPage + 2
    if (endPage > lastPage) endPage = lastPage

    let navArr = []
    if (startPage > 1) navArr.push("...")
    if (total > 0)
        while (endPage - startPage < 4) {
            if (endPage < lastPage) endPage++
            if (startPage > 1) startPage--

            if (startPage <= 1 && endPage >= lastPage) break
        }

    for (let i = startPage; i <= endPage; i++) {
        navArr.push(i)
    }
    if (endPage < lastPage) navArr.push("...")

    let id = 0
    const navItems = navArr.map((navItem) => (
        <PaginationItem key={id++} active={currentPage === navItem} disabled={navItem === "..."} onClick={() => handlePageClick(navItem)} >
            <PaginationLink>
                {navItem}
            </PaginationLink>
        </PaginationItem>
    ))

    const handlePageClick = (value) => {
        value = parseInt(value)
        if (value && value !== currentPage && value > 0 && value <= lastPage)
            setPager({ ...pager, offset: parseInt(value) * pager.size - pager.size })
    }

    return (
        <Pagination className="float-right" aria-label="Page navigation">
            <PaginationItem disabled={currentPage <= 1} onClick={() => handlePageClick(1)}>
                <PaginationLink first />
            </PaginationItem>
            <PaginationItem disabled={currentPage <= 1} onClick={() => handlePageClick(currentPage - 1)}>
                <PaginationLink previous />
            </PaginationItem>

            {navItems}

            <PaginationItem disabled={currentPage >= lastPage} onClick={() => handlePageClick(currentPage + 1)}>
                <PaginationLink next />
            </PaginationItem>
            <PaginationItem disabled={currentPage >= lastPage} onClick={() => handlePageClick(lastPage)}>
                <PaginationLink last />
            </PaginationItem>
        </Pagination>
    )

}
export default PaginationCustom